import { FormControl, FormErrorMessage, FormLabel, HStack, Select } from '@chakra-ui/react';
import { range } from 'lodash';
import { useTranslation } from 'react-i18next';

const HOUR_OPTIONS = range(0, 24);

export interface Duration {
  days: number;
  hours: number;
}

export function toDurationMinutes({ days, hours }: Duration) {
  return (days * 24 + hours) * 60;
}

interface Props {
  value: Duration;
  onChange: (value: Duration) => void;
  /** The largest number of days that can be picked. */
  maxDays: number;
  /** Shown under the fields when set. */
  errorMessage?: string;
}

/**
 * A duration picked as whole days plus hours, e.g. for how long access or a log capture lasts.
 */
export function DurationFields({ value, onChange, maxDays, errorMessage }: Props) {
  const { t } = useTranslation();

  return (
    <FormControl isInvalid={Boolean(errorMessage)}>
      <HStack spacing="4" alignItems="flex-start">
        <FormControl>
          <FormLabel>{t('days')}</FormLabel>
          <Select
            value={value.days}
            onChange={(event) => onChange({ ...value, days: Number(event.target.value) })}
          >
            {range(0, maxDays + 1).map((days) => (
              <option key={days} value={days}>
                {days}
              </option>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>{t('hours')}</FormLabel>
          <Select
            value={value.hours}
            onChange={(event) => onChange({ ...value, hours: Number(event.target.value) })}
          >
            {HOUR_OPTIONS.map((hours) => (
              <option key={hours} value={hours}>
                {hours}
              </option>
            ))}
          </Select>
        </FormControl>
      </HStack>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
}
